import React from 'react';
import Navigation from './components/Navigation';
import HeroSection from './components/HeroSection';
import ProblemSection from './components/ProblemSection';
import SolutionSection from './components/SolutionSection';
import BenefitsSection from './components/BenefitsSection';
import ResultsSection from './components/ResultsSection';
import ComparisonSection from './components/ComparisonSection';
import HowItWorksSection from './components/HowItWorksSection';
import GuaranteeSection from './components/GuaranteeSection';
import FAQSection from './components/FAQSection';
import QuizCTASection from './components/QuizCTASection';
import ContactSection from './components/ContactSection';
import UrgencySection from './components/UrgencySection';
import Footer from './components/Footer';

function App() {
  return (
    <div className="font-raleway">
      <Navigation />
      <HeroSection />
      <ProblemSection />
      <SolutionSection />
      <BenefitsSection />
      <ResultsSection />
      <ComparisonSection />
      <HowItWorksSection />
      <GuaranteeSection />
      <FAQSection />
      <QuizCTASection />
      <ContactSection />
      <UrgencySection />
      <Footer />
    </div>
  );
}

export default App;